export const thirdPartySandboxUrl =
  process.env.GATSBY_THIRD_PARTY_SANDBOX_URL || 'https://static.dfh.dev'
